
import { supabase } from './services/supabaseClient';
import { authService } from './services/auth.service';
import { empresasService } from './services/empresas.service';
import { produtosService } from './services/produtos.service';
import { pedidosService } from './services/pedidos.service';
import { customerService } from './services/customer.service';
import { insumosService } from './services/insumos.service';
import { fichaTecnicaService } from './services/fichaTecnica.service';

export { supabase };

export const supabaseService = {
  ...authService,
  ...empresasService,
  ...produtosService,
  ...pedidosService,
  ...customerService,
  ...insumosService,
  ...fichaTecnicaService
};
